/*eslint-disable*/

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import carte from "assets/images/carte.jpg"
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function BuiltByDevelopers() {
    

  return (
    <MKBox
      display="flex"
      alignItems="center"
      borderRadius="xl"
      my={2}
      py={6}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.8),
            rgba(gradients.dark.state, 0.8)
          )}, url(${carte})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}
    >
      <Container>
      <Grid 
  container 
  item 
  xs={12} 
  lg={12} 
  sx={{ mx: 2 }} // marge gauche et droite
>
  <MKTypography 
    variant="h4" 
    color="white" 
    fontWeight="bold" 
    sx={{ textAlign: "left" }}
  >
    ABCDElec Madagascar  - Depuis 2024
  </MKTypography>

  <MKTypography 
    variant="h1" 
    color="white" 
    sx={{ width: "100%", textAlign: "left" }}
  >
    Spécialiste SIG
  </MKTypography>

  <MKTypography 
    variant="body1" 
    color="white" 
    opacity={0.8} 
    sx={{ width: "100%", textAlign: "left" }}
  >
    Dans le cadre du Projet LEAD 424C – JIRAMA, financé par la Banque mondiale 
    pour l’électrification de plus de 25 000 compteurs, j’ai participé à la 
    réalisation de la cartographie SIG des branchements MORA. Mes missions 
    comprenaient la collecte, l’intégration et l’analyse de données spatiales 
    (GPS, imagerie satellite), la conception de cartes thématiques et de suivi 
    pour appuyer la prise de décision stratégique, ainsi que l’analyse des données 
    géospatiales afin d’identifier les zones prioritaires et d’optimiser les 
    interventions. J’ai également assuré le contrôle, l’administration et la 
    sécurisation des bases de données du projet (SIG, techniques et opérationnelles), 
    mis en place des processus automatisés sous QGIS pour accélérer les mises à jour, 
    et formé les équipes terrain à l’utilisation des outils SIG et GPS.
  </MKTypography>

</Grid>


      </Container>
    </MKBox>
  );
}

export default BuiltByDevelopers;
